import React, { useRef } from 'react';
import style from './add-intent.module.scss';
import { Modal } from '../../../components';
import { intent, entity } from './constants';

type Props = {
	onOk: () => void;
	onCancel: () => void;
	isOpen: boolean;
	onIntentNameChange: (intent: string) => void;
	initialIntentName?: string;
	isEdit?: boolean;
	loading?: boolean;
	error: string;
};

export function AddIntent(props: Props) {
	const inputRef = useRef(null);
	const {
		onOk,
		onCancel,
		isOpen,
		onIntentNameChange,
		initialIntentName = '',
		isEdit = false,
		loading = false,
		error,
	} = props;

	return (
		<Modal
			onOk={onOk}
			okText={isEdit ? 'Update' : 'Submit'}
			onCancel={onCancel}
			isOpen={isOpen}
			title={isEdit ? 'Edit Intent' : 'Add Intent'}
			loading={loading}
		>
			<div className={style.addIntentContent}>
				<p>
					{intent.title}
				</p>

				<p className={style.green} style={{ marginBottom: 0 }}>
				  {entity["sub-text-1"]}
				</p>
				<p className={style.green}>
				  {entity["sub-text-2"]}
				</p>

				<p style={{ lineHeight: '24px' }}>
					can be categorised under the{' '}
					<span className={style.emphasis}>OrderPizza</span> intent.
				</p>

				<div className={style.Form}>
					<label htmlFor="intentName">Intent Name</label>
					<input
						ref={inputRef}
						onKeyDown={(e) => {
							if (e.keyCode === 13) {
								{
									onOk();
								}
							}
						}}
						autoFocus
						defaultValue={initialIntentName}
						onChange={(e) => onIntentNameChange(e.target.value)}
						id="intentName"
						placeholder="Enter intent name"
					/>
					{error && <span className={style.error}>{error}</span>}
				</div>
			</div>
		</Modal>
	);
}
